import React from 'react'
import {Toolbar, SaveButton} from 'react-admin'

export const BottomToolBarWithSave = (props: any) => {
    return (
        <Toolbar {...props}>
            <SaveButton redirect={false}/>
        </Toolbar>)
}